import type { ProjectCaseStudy } from '@/data/projectCaseStudies'
import { projectStudySchema, projectStudyUrl } from '@/data/projectCaseStudies'
import { portfolioData } from '@/data/portfolio'

export function projectStudyHead(project: ProjectCaseStudy) {
  const image = `https://www.suriyaprakash.in/images/work/${project.slug}/homepage.jpg`
  return {
    meta: [
      { title: project.title },
      { name: 'description', content: project.description },
      { name: 'robots', content: 'index, follow, max-image-preview:large' },
      { name: 'author', content: portfolioData.personal.name },
      { property: 'og:type', content: 'article' },
      { property: 'og:site_name', content: portfolioData.personal.name },
      { property: 'og:locale', content: 'en_IN' },
      { property: 'og:title', content: project.title },
      { property: 'og:description', content: project.description },
      { property: 'og:url', content: projectStudyUrl(project) },
      { property: 'og:image', content: image },
      { property: 'og:image:width', content: '1440' },
      { property: 'og:image:height', content: '1000' },
      { property: 'og:image:alt', content: project.gallery[0].alt },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: project.title },
      { name: 'twitter:description', content: project.description },
      { name: 'twitter:image', content: image },
      { name: 'twitter:image:alt', content: project.gallery[0].alt },
    ],
    links: [{ rel: 'canonical', href: projectStudyUrl(project) }],
    scripts: [
      {
        type: 'application/ld+json',
        children: JSON.stringify(
          projectStudySchema(project, portfolioData.personal.name),
        ).replace(/</g, '\\u003c'),
      },
    ],
  }
}
